import { TicketChannel, TicketPriority, TicketStatus, TicketType } from './ticket.models';

export const STATUS_LABELS: Record<TicketStatus, string> = {
  NOVO: 'Novo',
  ABERTO: 'Aberto',
  PENDENTE: 'Pendente',
  EM_ESPERA: 'Em espera',
  RESOLVIDO: 'Resolvido',
  FECHADO: 'Fechado',
};

export const PRIORITY_LABELS: Record<TicketPriority, string> = {
  BAIXA: 'Baixa',
  NORMAL: 'Normal',
  ALTA: 'Alta',
  URGENTE: 'Urgente',
};

export const TYPE_LABELS: Record<TicketType, string> = {
  PERGUNTA: 'Pergunta',
  INCIDENTE: 'Incidente',
  PROBLEMA: 'Problema',
  TAREFA: 'Tarefa',
};

export const CHANNEL_LABELS: Record<TicketChannel, string> = {
  EMAIL: 'E-mail',
  PORTAL: 'Portal',
  TELEFONE: 'Telefone',
  CHAT: 'Chat',
  FORMULARIO: 'Formulário',
};

/** Ordem do ciclo de vida (não alfabética). */
export const STATUS_OPTIONS = (['NOVO', 'ABERTO', 'PENDENTE', 'EM_ESPERA', 'RESOLVIDO', 'FECHADO'] as TicketStatus[])
  .map((value) => ({ value, label: STATUS_LABELS[value] }));

/** Ordem crescente de urgência. */
export const PRIORITY_OPTIONS = (['BAIXA', 'NORMAL', 'ALTA', 'URGENTE'] as TicketPriority[])
  .map((value) => ({ value, label: PRIORITY_LABELS[value] }));

export const TYPE_OPTIONS = (['PERGUNTA', 'INCIDENTE', 'PROBLEMA', 'TAREFA'] as TicketType[])
  .map((value) => ({ value, label: TYPE_LABELS[value] }));

export const CHANNEL_OPTIONS = (['EMAIL', 'PORTAL', 'TELEFONE', 'CHAT', 'FORMULARIO'] as TicketChannel[])
  .map((value) => ({ value, label: CHANNEL_LABELS[value] }));

/** Classe do badge de status (soft badges do tema Front). */
export function statusBadge(status: TicketStatus): string {
  switch (status) {
    case 'NOVO':
      return 'bg-primary-soft';
    case 'ABERTO':
      return 'bg-info-soft';
    case 'PENDENTE':
      return 'bg-warning-soft';
    case 'EM_ESPERA':
      return 'bg-secondary-soft';
    case 'RESOLVIDO':
      return 'bg-success-soft';
    case 'FECHADO':
      return 'bg-secondary-soft';
  }
}

/** Classe do badge de prioridade. */
export function priorityBadge(priority: TicketPriority): string {
  switch (priority) {
    case 'BAIXA':
      return 'bg-secondary-soft';
    case 'NORMAL':
      return 'bg-info-soft';
    case 'ALTA':
      return 'bg-warning-soft';
    case 'URGENTE':
      return 'bg-danger-soft';
  }
}

/** Classe do badge de tipo. */
export function typeBadge(type: TicketType): string {
  switch (type) {
    case 'PERGUNTA':
      return 'bg-info-soft';
    case 'INCIDENTE':
      return 'bg-warning-soft';
    case 'PROBLEMA':
      return 'bg-danger-soft';
    case 'TAREFA':
      return 'bg-secondary-soft';
  }
}

/** Ícone do tipo (feather). */
export function typeIcon(type: TicketType): string {
  switch (type) {
    case 'PERGUNTA':
      return 'fe-help-circle';
    case 'INCIDENTE':
      return 'fe-alert-triangle';
    case 'PROBLEMA':
      return 'fe-alert-octagon';
    case 'TAREFA':
      return 'fe-check-square';
  }
}

/** Ícone do canal (feather). */
export function channelIcon(channel: TicketChannel): string {
  switch (channel) {
    case 'EMAIL':
      return 'fe-mail';
    case 'PORTAL':
      return 'fe-globe';
    case 'TELEFONE':
      return 'fe-phone';
    case 'CHAT':
      return 'fe-message-circle';
    case 'FORMULARIO':
      return 'fe-file-text';
  }
}
